import { Component, OnInit, ElementRef, ViewChild, Input, Output, EventEmitter } from '@angular/core';
import { TournamentsService } from '~/legacy/ts/tournaments/services/tournaments.service';

@Component({
    selector: 'scoreView',
    templateUrl: './score.view.html',
})
export class ScoreView implements OnInit {
    @Input() sportTypeEnum = 2;
    @Input() fixtureItem: any;
    defaultSwitch = true;
    styles = {
        spans: {
            color: '#01FF00',
            'font-size': '20px',
            'font-weight': 'bold',
            'text-shadow': '1px 1px 1px #000000',
        },
    };

    constructor(public tournamentsService: TournamentsService) {}

    ngOnInit() {
        //console.log(this.sportTypeEnum);
        this.defaultSwitch = this.sportTypeEnum != 5;
    }
}
